(function () {
  "use strict";

  var DEBUG = window.__linkedSwapDebug || false;
  var isSwapping = false;

  // Track which product is currently displayed
  var swapState = {
    isSwapped: false,
    originalProduct: null,
    linkedProduct: null,
    selectedColor: null,
    originalBlocksHtml: null
  };

  // Save original product data at page load (before any swap overwrites it)
  try {
    var _pdEl = document.getElementById("productData");
    if (_pdEl) swapState.originalProduct = JSON.parse(_pdEl.textContent);
  } catch (e) { /* will be set on first swap */ }

  // ---- Helpers ----

  function showLoading() {
    var mp = document.querySelector(".m-main-product");
    if (mp) {
      mp.style.pointerEvents = "none";
    }
  }

  function hideLoading() {
    var mp = document.querySelector(".m-main-product");
    if (mp) {
      mp.style.pointerEvents = "";
    }
  }

  function fmtMoney(cents) {
    var format = (window.MinimogSettings && window.MinimogSettings.money_format) || "${{amount}}";
    if (typeof cents === "string") cents = cents.replace(".", "");
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var match = format.match(placeholderRegex);
    if (!match) return "$" + (cents / 100).toFixed(2);
    var value;
    switch (match[1]) {
      case "amount":
        value = (cents / 100).toFixed(2);
        break;
      case "amount_no_decimals":
        value = Math.round(cents / 100);
        break;
      default:
        value = (cents / 100).toFixed(2);
    }
    return format.replace(placeholderRegex, value);
  }

  function triggerLazyImages(container) {
    if (!container) return;
    container.querySelectorAll("img[loading='lazy']").forEach(function (img) {
      img.loading = "eager";
    });
  }

  function filterGalleryToVariantMedia(container, variantMediaIds) {
    if (!container || !variantMediaIds || !variantMediaIds.length) return null;

    var selectedIds = variantMediaIds.map(function (id) { return String(id); });
    var galleries = container.querySelectorAll(
      "media-gallery, media-gallery-mobile, [data-upgrade-ce='media-gallery'], [data-upgrade-ce='media-gallery-mobile']"
    );
    var summary = [];

    galleries.forEach(function (gallery) {
      var mediaWrapper = gallery.querySelector(".m-media-gallery__list");
      if (!mediaWrapper) return;

      var items = Array.from(mediaWrapper.children).filter(function (item) {
        return item.classList && item.classList.contains("m-product-media--item");
      });
      if (!items.length) return;

      var selectedItems = items.filter(function (item) {
        return selectedIds.indexOf(String(item.dataset.mediaId)) !== -1 || item.dataset.mediaType !== "image";
      });
      if (!selectedItems.length || selectedItems.length === items.length) return;

      var orderedItems = selectedIds.map(function (id) {
        return selectedItems.find(function (item) { return String(item.dataset.mediaId) === id; });
      }).filter(Boolean);
      var remainingItems = selectedItems.filter(function (item) {
        return selectedIds.indexOf(String(item.dataset.mediaId)) === -1;
      });
      var nextItems = orderedItems.concat(remainingItems);
      var layout = gallery.dataset.layout;

      mediaWrapper.innerHTML = "";
      nextItems.forEach(function (item, index) {
        item.dataset.index = index;
        item.removeAttribute("style");

        if (layout === "layout-2") {
          item.classList.remove("m-col-span-2");
          if (index % 3 === 0) item.classList.add("m-col-span-2");
        }

        var mediaInner = item.querySelector(".m-product-media");
        if (mediaInner) {
          mediaInner.setAttribute("style", "--animation-order: " + (index + 1) + ";");
        }

        mediaWrapper.append(item);
      });

      var thumbWrapper = gallery.querySelector(".m-product-media--slider__thumbnails .swiper-wrapper");
      if (thumbWrapper) {
        var thumbs = Array.from(thumbWrapper.children).filter(function (thumb) {
          return thumb.dataset && thumb.dataset.mediaType;
        });
        var selectedThumbs = thumbs.filter(function (thumb) {
          return selectedIds.indexOf(String(thumb.dataset.mediaId)) !== -1 || thumb.dataset.mediaType !== "image";
        });
        var orderedThumbs = selectedIds.map(function (id) {
          return selectedThumbs.find(function (thumb) { return String(thumb.dataset.mediaId) === id; });
        }).filter(Boolean);
        var remainingThumbs = selectedThumbs.filter(function (thumb) {
          return selectedIds.indexOf(String(thumb.dataset.mediaId)) === -1;
        });

        thumbWrapper.innerHTML = "";
        orderedThumbs.concat(remainingThumbs).forEach(function (thumb, index) {
          thumb.dataset.index = index;
          thumb.classList.toggle("swiper-slide-thumb-active", index === 0);
          thumbWrapper.append(thumb);
        });
      }

      gallery.dataset.mediaSize = String(nextItems.length);
      summary.push(gallery.tagName + ":" + items.length + "->" + nextItems.length);
    });

    return summary.length ? summary : null;
  }

  // ---- Read current Swatch King selections ----

  function getCurrentSelectedOptions() {
    var options = {};
    // Read from Swatch King's selected swatches in the main product (not .linkedprod)
    var allSK = document.querySelectorAll("variant-swatch-king");
    for (var i = 0; i < allSK.length; i++) {
      var sk = allSK[i];
      if (sk.closest(".linkedprod")) continue;
      // Check if this is inside the main product variant picker
      if (!sk.closest(".main-product__block-variant_picker")) continue;

      sk.querySelectorAll("[id^='swatch-option']").forEach(function (optDiv) {
        var optName = optDiv.getAttribute("option-name");
        if (!optName) return;
        // Find selected swatch
        var selected = optDiv.querySelector(".swatch-selected, [aria-checked='true']");
        if (selected) {
          var val = selected.getAttribute("orig-value") || selected.getAttribute("data-value");
          if (val) options[optName.toLowerCase()] = val;
        }
      });
      break; // only first main SK
    }
    return options;
  }

  // ---- Find matching variant in target product ----

  function findMatchingVariant(product, targetColor, currentOptions) {
    if (!product || !product.variants) return null;
    var tColor = targetColor ? targetColor.toLowerCase() : null;

    // Try to find variant that matches targetColor + current Size/Print.
    var best = null;
    product.variants.forEach(function (v) {
      // Check if this variant has the target color
      var hasColor = false;
      for (var i = 0; i < v.options.length; i++) {
        if (v.options[i] && tColor && v.options[i].toLowerCase() === tColor) {
          hasColor = true;
          break;
        }
      }
      if (!hasColor) return;

      // Check if Size/Print match current selection
      var matchScore = 0;
      product.options.forEach(function (optObj, idx) {
        var optName = (typeof optObj === "string" ? optObj : optObj.name || "").toLowerCase();
        if (optName === "color") return; // skip color, we already matched
        var currentVal = currentOptions[optName];
        if (currentVal && v.options[idx] === currentVal) {
          matchScore++;
        }
      });

      // Highest option-match score wins. Do NOT pre-filter by availability:
      // the exact size+color the user has selected must win even when it is OOS,
      // so updateForm() reflects its true sold-out state on the ATC button
      // (previously an OOS selected size was silently replaced by an available
      // different size, leaving the button enabled). Availability is only a
      // tie-breaker between variants with the SAME option-match score.
      if (!best
          || matchScore > best.score
          || (matchScore === best.score && !best.variant.available && v.available)) {
        best = { variant: v, score: matchScore };
      }
    });

    // Fallback: first variant with matching color (even if unavailable)
    if (!best) {
      product.variants.forEach(function (v) {
        if (best) return;
        for (var i = 0; i < v.options.length; i++) {
          if (v.options[i] && tColor && v.options[i].toLowerCase() === tColor) {
            best = { variant: v, score: 0 };
            return;
          }
        }
      });
    }

    return best ? best.variant : product.variants[0];
  }

  // ---- Update DOM elements ----

  function updateTitle(product) {
    document.querySelectorAll(".m-product-title").forEach(function (el) {
      // Keep the <a> tag if it exists, just update text
      var link = el.querySelector("a");
      if (link) {
        link.textContent = product.title;
        link.href = product.url;
      } else {
        el.textContent = product.title;
      }
    });
  }

  function applyPriceToContainer(container, variant, onSale) {
    if (!container) return;
    var salePriceEl = container.querySelector(".m-price-item--sale");
    var comparePriceEl = container.querySelector(".m-price-item--regular");
    var strikeEl = container.querySelector(".warnaDiskon");

    if (salePriceEl) salePriceEl.innerHTML = fmtMoney(variant.price);
    if (comparePriceEl) comparePriceEl.innerHTML = fmtMoney(onSale ? variant.compare_at_price : variant.price);
    if (strikeEl) {
      strikeEl.innerHTML = onSale ? fmtMoney(variant.compare_at_price) : fmtMoney(variant.price);
      strikeEl.style.display = onSale ? "" : "none";
    }

    var priceContainer = container.querySelector(".m-price");
    if (priceContainer) {
      priceContainer.classList.toggle("m-price--on-sale", onSale);
    }

    var saleBadge = container.querySelector(".m-price__badge-sale");
    var saleAmount = container.querySelector("[data-saved-price]");
    if (saleBadge) {
      saleBadge.style.display = onSale ? "" : "none";
      if (onSale && saleAmount) {
        var percent = Math.round(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price);
        saleAmount.innerHTML = percent + "%";
      }
    }
  }

  function updatePrice(variant) {
    if (!variant) return;
    var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;

    // Desktop price (rendered by 'price' block in main-product-blocks.liquid)
    applyPriceToContainer(document.querySelector(".product-block-group--price"), variant, onSale);

    // Mobile price (#MobilePrice-{section.id} in sections/main-product.liquid:138)
    document.querySelectorAll("[id^='MobilePrice-']").forEach(function (mobile) {
      applyPriceToContainer(mobile, variant, onSale);
    });
  }

  function updateForm(product, variant) {
    if (!variant) return;
    DEBUG && console.log("[LinkedSwap:updateForm] setting variant ID:", variant.id, "title:", variant.title, "product:", product.handle);
    // Update all variant ID inputs
    document.querySelectorAll("input[name='id']").forEach(function (input) {
      DEBUG && console.log("[LinkedSwap:updateForm] input[name=id] before:", input.value, "→ after:", variant.id);
      input.value = variant.id;
      input.setAttribute("value", variant.id);
    });

    // Update sticky ATC select[name='id'] — rebuild options with current product's variants
    document.querySelectorAll("select[name='id']").forEach(function (select) {
      var oldVal = select.value;
      // Save original options HTML on first swap for restore
      if (!swapState._originalSelectHtml) {
        swapState._originalSelectHtml = select.innerHTML;
        DEBUG && console.log("[LinkedSwap:updateForm] sticky ATC: saved original select HTML, options:", select.options.length);
      }
      var placeholder = select.querySelector("option[disabled]");
      var html = '<option value="" disabled>' + (placeholder ? placeholder.textContent : "Select option") + '</option>';
      product.variants.forEach(function (v) {
        var label = v.option1 || "";
        if (v.option3) label += " / " + v.option3;
        label += " - " + fmtMoney(v.price);
        var sel = (v.id === variant.id) ? ' selected="true"' : '';
        html += '<option value="' + v.id + '"' + sel + '>' + label + '</option>';
      });
      select.innerHTML = html;
      select.value = variant.id;
      DEBUG && console.log("[LinkedSwap:updateForm] sticky ATC select[name=id] before:", oldVal, "→ after:", variant.id, "options:", product.variants.length, "product:", product.handle);
    });

    // Update form data attributes
    document.querySelectorAll("[data-type='add-to-cart-form']").forEach(function (form) {
      form.setAttribute("data-product-id", product.id);
      form.setAttribute("data-product-handle", product.handle);
    });

    // Update product-form custom element
    document.querySelectorAll("product-form").forEach(function (pf) {
      pf.setAttribute("data-product-id", product.id);
      pf.setAttribute("data-product-handle", product.handle);
    });

    // Update ATC button state (all forms including sticky ATC)
    var atcButtons = document.querySelectorAll(".m-add-to-cart");
    atcButtons.forEach(function (btn) {
      if (variant.available) {
        btn.disabled = false;
        btn.classList.remove("disabled");
        var textEl = btn.querySelector(".m-add-to-cart--text");
        if (textEl) textEl.textContent = btn.getAttribute("data-atc-text") || "Add to cart";
      } else {
        btn.disabled = true;
        btn.classList.add("disabled");
        var textEl2 = btn.querySelector(".m-add-to-cart--text");
        if (textEl2) textEl2.textContent = "Sold out";
      }
    });

    // Fix price visibility — variant-picker's setUnavailable() hides it
    var priceWrapper = document.querySelector(".product-block-group--price .m-price");
    if (priceWrapper) priceWrapper.classList.remove("m:visibility-hidden");
  }

  function updateProductData(product) {
    // Update #productData JSON
    var pdEl = document.querySelector("#productData");
    if (pdEl) {
      pdEl.textContent = JSON.stringify(product);
    }

    // Update _themeProducts global
    window._themeProducts = window._themeProducts || {};
    window._themeProducts[product.id] = {
      id: product.id,
      title: product.title,
      available: product.available,
      handle: product.handle,
      variants: product.variants,
      options: product.options,
      media: product.media,
      featured_image: product.featured_image,
      images: product.images,
      price: product.price
    };

    // Update data attributes on root element
    var mp = document.querySelector(".m-main-product");
    if (mp) {
      mp.dataset.productHandle = product.handle;
      mp.dataset.productUrl = product.url;
      mp.dataset.productId = product.id;
    }
  }

  // Apply Swatch King's `swatch-item-unavailable` class on swatches that SK
  // does not know are OOS — namely cross-product linked swatches and master
  // native swatches viewed after a swap to the linked product. SK's own CSS
  // renders the strike-through (.star-set-image::after) keyed on this class.
  // Also mirror to theme class `swatch-view-item--soldout` for consistency.
  function refreshSwatchOOSState() {
    // Build availability map for linked colors from server-rendered JSON
    var linkedAvail = {};
    try {
      var dataEl = document.getElementById("linkedColorSwatchesData");
      if (dataEl) {
        var cfg = JSON.parse(dataEl.textContent);
        (cfg.products || []).forEach(function (p) {
          (p.colors || []).forEach(function (c) {
            if (c && c.value) linkedAvail[c.value.toLowerCase()] = !!c.available;
          });
        });
      }
    } catch (e) {
      DEBUG && console.warn("[LinkedSwap:refreshSwatchOOSState] linkedColorSwatchesData parse failed:", e);
    }

    // Build master color availability map (any-variant-available per color)
    var masterColorAvail = {};
    var master = swapState.originalProduct;
    if (master && master.variants && master.options) {
      var masterColorIdx = master.options.findIndex(function (o) {
        var name = (typeof o === "string" ? o : o.name || "").toLowerCase();
        return name === "color";
      });
      if (masterColorIdx > -1) {
        master.variants.forEach(function (v) {
          var val = v.options[masterColorIdx];
          if (!val) return;
          var key = val.toLowerCase();
          masterColorAvail[key] = masterColorAvail[key] || v.available;
        });
      }
    }

    // Active product for non-color option (size/print) availability checks
    var activeProduct = swapState.isSwapped ? swapState.linkedProduct : swapState.originalProduct;

    // Resolve current color for per-combo size strike rule below.
    // Prefer current variant from input[name=id], fallback to swapState.selectedColor.
    var curColorVal = null;
    if (activeProduct && activeProduct.variants && activeProduct.options) {
      var aColorIdx = activeProduct.options.findIndex(function (o) {
        var name = (typeof o === "string" ? o : o.name || "").toLowerCase();
        return name === "color";
      });
      if (aColorIdx > -1) {
        var inputId = document.querySelector("input[name='id']");
        if (inputId) {
          var vid = Number(inputId.value);
          var cv = activeProduct.variants.find(function (v) { return v.id === vid; });
          if (cv) curColorVal = cv.options[aColorIdx];
        }
        if (!curColorVal) curColorVal = swapState.selectedColor || null;
      }
    }

    document.querySelectorAll("variant-swatch-king").forEach(function (sk) {
      if (sk.closest(".linkedprod")) return;
      if (!sk.closest(".main-product__block-variant_picker")) return;

      sk.querySelectorAll("[id^='swatch-option']").forEach(function (optDiv) {
        var optName = (optDiv.getAttribute("option-name") || "").toLowerCase();
        var isColor = optName === "color";

        // For non-color options, resolve option index in active product
        var optIdx = -1;
        if (!isColor && activeProduct && activeProduct.options) {
          optIdx = activeProduct.options.findIndex(function (o) {
            var name = (typeof o === "string" ? o : o.name || "").toLowerCase();
            return name === optName;
          });
        }

        optDiv.querySelectorAll(".swatch-view-item").forEach(function (sw) {
          var val = sw.getAttribute("orig-value");
          if (!val) return;
          var key = val.toLowerCase();
          var isLinked = sw.classList.contains("swatch-view-item--linked");

          var oos = null; // null = leave alone (defer to SK)

          if (isColor && isLinked) {
            if (key in linkedAvail) oos = (linkedAvail[key] === false);
          } else if (isColor && !isLinked) {
            // Master native color — apply OOS from master variants. SK strips
            // this class when current productData is the linked product, so
            // we re-assert. When unswapped, master matches SK's productData
            // and re-asserting matches SK anyway.
            if (key in masterColorAvail) oos = (masterColorAvail[key] === false);
          } else if (optIdx > -1 && activeProduct && activeProduct.variants) {
            // Per-combo rule: strike a size only if (currentColor + thisSize)
            // variant is unavailable. Naturally covers fully-OOS color (every
            // combo unavailable → every size struck) AND partial-OOS color
            // (only specific OOS sizes struck). Matches SK's server-rendered intent.
            var aColorIdx2 = activeProduct.options.findIndex(function (o) {
              var name = (typeof o === "string" ? o : o.name || "").toLowerCase();
              return name === "color";
            });
            var sameSize = activeProduct.variants.filter(function (v) {
              return v.options[optIdx] === val;
            });
            if (!sameSize.length) return; // size not present in active product — leave alone

            if (aColorIdx2 > -1 && curColorVal) {
              var combo = sameSize.find(function (v) {
                return v.options[aColorIdx2] &&
                  v.options[aColorIdx2].toLowerCase() === curColorVal.toLowerCase();
              });
              if (!combo) return; // combo missing — leave alone
              oos = !combo.available;
            } else {
              // No color option — fall back to any-variant rule
              oos = !sameSize.some(function (v) { return v.available; });
            }
          }

          if (oos === null) return;

          if (oos) {
            sw.classList.add("swatch-item-unavailable");
            sw.classList.add("swatch-view-item--soldout");
          } else {
            sw.classList.remove("swatch-item-unavailable");
            sw.classList.remove("swatch-view-item--soldout");
          }
        });
      });
    });

    // Self-heal selection ring. While swapped, the authoritative color is the
    // linked color we swapped to; SK may re-add `swatch-selected` to its
    // remembered native swatch on a late tick → double ring. Re-assert single
    // selection. Runs via this rAF-debounced refresh (SK MutationObserver +
    // refresh_product), so any stray is corrected within a frame. Skipped when
    // not swapped so normal master selection stays owned by Swatch King.
    if (swapState.isSwapped && swapState.selectedColor) {
      reassertSelectedColor(swapState.selectedColor);
    }

    DEBUG && console.log("[LinkedSwap:refreshSwatchOOSState] done.");
  }

  // rAF-debounced refresh — collapses bursts of SK mutations into one pass
  var _refreshQueued = false;
  function queueSwatchOOSRefresh() {
    if (_refreshQueued) return;
    _refreshQueued = true;
    requestAnimationFrame(function () {
      _refreshQueued = false;
      refreshSwatchOOSState();
    });
  }

  // Post-swap schedule: rAF (synchronous after current paint) + one short
  // fallback in case SK's mutation happens after the rAF window.
  function scheduleSwatchOOSRefresh() {
    queueSwatchOOSRefresh();
    setTimeout(queueSwatchOOSRefresh, 100);
  }

  // Observe SK DOM for class/childList mutations and trigger refresh.
  // Eliminates the multi-second delay between SK's re-render and our re-apply.
  var _swatchObservers = [];
  function setupSwatchOOSObserver() {
    _swatchObservers.forEach(function (o) { o.disconnect(); });
    _swatchObservers = [];
    document.querySelectorAll("variant-swatch-king").forEach(function (sk) {
      if (sk.closest(".linkedprod")) return;
      if (!sk.closest(".main-product__block-variant_picker")) return;
      var obs = new MutationObserver(function () {
        queueSwatchOOSRefresh();
      });
      obs.observe(sk, {
        attributes: true,
        attributeFilter: ["class"],
        subtree: true,
        childList: true
      });
      _swatchObservers.push(obs);
    });
  }

  // Direct event hook — fires immediately after our own dispatch (and any
  // SK listener that ran before us). Bypasses observer rAF if available.
  window.addEventListener("refresh_product", function () {
    queueSwatchOOSRefresh();
  });

  // Resolve the main-product Swatch King Color option container (skips the
  // hidden .linkedprod section and any product-card pickers). Returns the
  // `[option-name="Color"]` div or null.
  function getMainColorOptionDiv() {
    var allSK = document.querySelectorAll("variant-swatch-king");
    for (var i = 0; i < allSK.length; i++) {
      var sk = allSK[i];
      if (sk.closest(".linkedprod")) continue;
      if (!sk.closest(".main-product__block-variant_picker")) continue;
      var div = sk.querySelector('[option-name="Color"], [option-name="color"]');
      if (div) return div;
    }
    return null;
  }

  // Set the selected ring on swatches matching `colorValue` and clear it from
  // all others in `colorOptionDiv`. Each attribute/class is written ONLY when it
  // actually differs, so re-running on already-correct state mutates nothing —
  // critical because the SK MutationObserver re-triggers this; no-op convergence
  // prevents a feedback loop.
  function applySelectedSwatch(colorOptionDiv, colorValue) {
    if (!colorOptionDiv || !colorValue) return;
    var target = colorValue.toLowerCase();
    colorOptionDiv.querySelectorAll(".swatch-view-item").forEach(function (swatch) {
      var origVal = swatch.getAttribute("orig-value");
      var isTarget = !!(origVal && origVal.toLowerCase() === target);

      var ariaWant = isTarget ? "true" : "false";
      if (swatch.getAttribute("aria-checked") !== ariaWant) {
        swatch.setAttribute("aria-checked", ariaWant);
      }
      var tabWant = isTarget ? "0" : "-1";
      if (swatch.getAttribute("tabindex") !== tabWant) {
        swatch.setAttribute("tabindex", tabWant);
      }

      var inner = swatch.querySelector(".swatch-image");
      if (inner) {
        var has = inner.classList.contains("swatch-selected");
        if (isTarget && !has) inner.classList.add("swatch-selected");
        else if (!isTarget && has) inner.classList.remove("swatch-selected");
      }
    });
  }

  function updateSwatchKingSelectedColor(colorValue) {
    if (!colorValue) return;
    var colorOptionDiv = getMainColorOptionDiv();
    if (!colorOptionDiv) return;

    // Update the VISIBLE color label (e.g. "COLOR: Hot Pink" → "COLOR: Navy Heather")
    // Structure: <label class="swatch-label"> → <span class="swatch-variant-name">: Hot Pink</span>
    var variantNameSpan = colorOptionDiv.querySelector(".swatch-variant-name");
    if (variantNameSpan) {
      variantNameSpan.textContent = ": " + colorValue;
    }

    // Also update the hidden label for accessibility
    var labelContainer = colorOptionDiv.querySelector(".swatch-label-container");
    if (labelContainer) {
      var labelSpans = labelContainer.querySelectorAll("span");
      if (labelSpans.length > 0) {
        labelSpans[labelSpans.length - 1].textContent = colorValue;
      }
    }

    applySelectedSwatch(colorOptionDiv, colorValue);
  }

  // Self-heal the selection ring after Swatch King re-asserts its own remembered
  // native selection on a late async (animation / refresh_product) tick — which
  // otherwise leaves two visible rings: the swapped-to linked swatch PLUS SK's
  // stale native swatch. Re-applies single selection to `colorValue`. Ring/aria
  // only (does not touch the label). Idempotent — safe to call repeatedly.
  function reassertSelectedColor(colorValue) {
    if (!colorValue) return;
    applySelectedSwatch(getMainColorOptionDiv(), colorValue);
  }

  function updateMedia(handle, targetVariant, cachedProduct) {
    DEBUG && console.log("[LinkedSwap:updateMedia] START — handle:", handle, "variantId:", targetVariant && targetVariant.id, "cached:", !!cachedProduct);
    var mp = document.querySelector(".m-main-product");
    if (!mp) { DEBUG && console.warn("[LinkedSwap:updateMedia] .m-main-product NOT FOUND"); return Promise.resolve(); }

    var sectionId = mp.dataset.sectionId;
    if (!sectionId || typeof fetchSection !== "function") {
      DEBUG && console.warn("[LinkedSwap:updateMedia] sectionId or fetchSection missing. sectionId:", sectionId, "fetchSection:", typeof fetchSection);
      return Promise.resolve();
    }

    var baseUrl = (window.MinimogSettings && window.MinimogSettings.base_url) || "/";
    var fetchUrl = baseUrl + "products/" + handle;
    if (targetVariant) fetchUrl += "?variant=" + targetVariant.id;
    // Note: no cache-buster. Allows browser to reuse the <link rel=prefetch>
    // emitted on swatch hover (linked-color-swatches.js mouseenter handler) →
    // instant swap on second hover→click sequence. Shopify section API
    // returns fresh content per ?variant= URL, so staleness risk is minimal.

    DEBUG && console.log("[LinkedSwap:updateMedia] fetchUrl:", fetchUrl, "sectionId:", sectionId);

    return fetchSection(sectionId, { url: fetchUrl })
      .then(function (fetchedDom) {
        DEBUG && console.log("[LinkedSwap:updateMedia] fetchSection resolved");
        var wrapper = document.querySelector(".m-main-product--wrapper");
        var fetchedWrapper = fetchedDom.querySelector(".m-main-product--wrapper");
        if (!wrapper || !fetchedWrapper) {
          DEBUG && console.warn("[LinkedSwap:updateMedia] wrapper missing. current:", !!wrapper, "fetched:", !!fetchedWrapper);
          return;
        }

        var currentMedia = wrapper.querySelector(".m-main-product--media");
        var fetchedMedia = fetchedWrapper.querySelector(".m-main-product--media");
        if (!currentMedia || !fetchedMedia) {
          DEBUG && console.warn("[LinkedSwap:updateMedia] media container missing. current:", !!currentMedia, "fetched:", !!fetchedMedia);
          return;
        }

        // Extract variant group images data from fetched variant-picker
        // This tells us which media IDs belong to which variant
        var variantGroupData = null;
        // Script lives inside <product-info> but OUTSIDE .m-main-product--wrapper,
        // so fall back to the section root (fetchedDom) if not in wrapper.
        var fetchedVGElement = fetchedWrapper.querySelector("#variantGroup[type='application/json']")
          || fetchedDom.querySelector("#variantGroup[type='application/json']");
        if (DEBUG) {
          var vgInWrapper = fetchedWrapper.outerHTML.indexOf("variantGroup") > -1;
          var vgInDom = (fetchedDom.outerHTML || fetchedDom.innerHTML).indexOf("variantGroup") > -1;
          console.log("[LinkedSwap:updateMedia:diag] fetchedVGElement found:", !!fetchedVGElement,
            "| in fetchedWrapper:", vgInWrapper,
            "| in fetchedDom:", vgInDom,
            "| textContent length:", fetchedVGElement ? fetchedVGElement.textContent.length : -1,
            "| textContent preview:", fetchedVGElement ? JSON.stringify(fetchedVGElement.textContent.slice(0, 200)) : "(null)");
        }
        if (fetchedVGElement) {
          try { variantGroupData = JSON.parse(fetchedVGElement.textContent); } catch (e) {
            DEBUG && console.log("[LinkedSwap:updateMedia] variantGroup JSON parse failed:", e);
          }
          // Inject fresh #variantGroup JSON into live DOM so variant-picker reads correct mapping
          var liveVGElement = document.querySelector("#variantGroup[type='application/json']");
          if (liveVGElement) {
            liveVGElement.textContent = fetchedVGElement.textContent;
            DEBUG && console.log("[LinkedSwap:updateMedia] #variantGroup JSON updated in DOM");
          }
        }
        DEBUG && console.log("[LinkedSwap:updateMedia] variantGroupData:", variantGroupData ? {
          enable: variantGroupData.enable,
          mappingCount: variantGroupData.mapping && variantGroupData.mapping.length,
          sampleIds: variantGroupData.mapping && variantGroupData.mapping.slice(0, 3).map(function(m){return m.id;})
        } : null);

        // Find which media IDs belong to the target variant
        var variantMediaIds = null;
        if (variantGroupData && variantGroupData.enable && variantGroupData.mapping && targetVariant) {
          var mapping = variantGroupData.mapping.find(function (m) {
            return Number(m.id) === targetVariant.id;
          });
          if (mapping && mapping.media && mapping.media.length > 0) {
            variantMediaIds = mapping.media;
          }
          DEBUG && console.log("[LinkedSwap:updateMedia] variant mapping for ID", targetVariant.id, "→", variantMediaIds);
        } else {
          DEBUG && console.log("[LinkedSwap:updateMedia] no variantGroup filtering — will show all media");
        }

        // Strip custom element tags → insert as divs → upgrade after in DOM
        var mediaHTML = fetchedMedia.innerHTML;
        mediaHTML = mediaHTML
          .replace(/<media-gallery-mobile\b/g, "<div data-upgrade-ce='media-gallery-mobile'")
          .replace(/<\/media-gallery-mobile>/g, "</div>")
          .replace(/<media-gallery\b/g, "<div data-upgrade-ce='media-gallery'")
          .replace(/<\/media-gallery>/g, "</div>");

        // Hide gallery briefly to mask the period between full-set insert and
        // filter. media-gallery-mobile (swiper) on mobile renders ALL inserted
        // slides before handleVariantGroupImage trims them → user sees a long
        // multi-slide strip flicker. Hidden until syncVariantPicker → pi.updateMedia
        // → handleVariantGroupImage completes; restored at end of syncVariantPicker.
        // Desktop grid layout renders instantly so flicker isn't visible, but
        // hiding adds no perceived delay there either.
        currentMedia.style.visibility = "hidden";

        currentMedia.innerHTML = mediaHTML;
        DEBUG && console.log("[LinkedSwap:updateMedia] innerHTML replaced. placeholders:", currentMedia.querySelectorAll("[data-upgrade-ce]").length);

        // NOTE: do NOT pre-filter DOM via filterGalleryToVariantMedia. Keep all
        // linked product media items in DOM so pi.initialMedias holds the full
        // set. handleVariantGroupImage in product-info will filter to current
        // variant. Pre-filtering would limit initialMedias to one variant's
        // subset, breaking subsequent size/print changes (no media to filter from).
        if (variantMediaIds) {
          DEBUG && console.log("[LinkedSwap:updateMedia] variant mapping carries", variantMediaIds.length, "media IDs — handleVariantGroupImage will filter");
        }

        triggerLazyImages(currentMedia);

        // Upgrade placeholders to real custom elements
        requestAnimationFrame(function () {
          var upgradeCount = 0;
          currentMedia.querySelectorAll("[data-upgrade-ce]").forEach(function (placeholder) {
            var tagName = placeholder.getAttribute("data-upgrade-ce");
            var attrs = "";
            Array.from(placeholder.attributes).forEach(function (attr) {
              if (attr.name !== "data-upgrade-ce") {
                attrs += " " + attr.name + '="' + attr.value.replace(/"/g, "&quot;") + '"';
              }
            });
            placeholder.outerHTML = "<" + tagName + attrs + ">" + placeholder.innerHTML + "</" + tagName + ">";
            upgradeCount++;
          });
          DEBUG && console.log("[LinkedSwap:updateMedia] Upgraded", upgradeCount, "custom elements");

          // Re-init media galleries after upgrade
          requestAnimationFrame(function () {
            var galleries = currentMedia.querySelectorAll("media-gallery, media-gallery-mobile");
            DEBUG && console.log("[LinkedSwap:updateMedia] media-gallery elements found:", galleries.length);

            // Sync variant-picker stale references (media, slides, slidesNav, mediaItems, variantGroupImages, productData)
            var syncVariantPicker = function (el) {
              var vp = document.querySelector(".m-main-product--wrapper variant-picker");
              if (!vp) return;
              // Refresh both gallery refs from current DOM so neither is stale
              vp.mediaGallery = currentMedia.querySelector("media-gallery") || vp.mediaGallery;
              vp.mediaGalleryMobile = currentMedia.querySelector("media-gallery-mobile") || vp.mediaGalleryMobile;
              // Pick visible gallery (offsetParent !== null means rendered/visible).
              // Falls back to mqlMobile flag, then to passed-in el.
              var isVisible = function (g) { return g && g.offsetParent !== null; };
              var effective = null;
              if (isVisible(vp.mediaGalleryMobile)) effective = vp.mediaGalleryMobile;
              else if (isVisible(vp.mediaGallery)) effective = vp.mediaGallery;
              if (!effective) {
                var isMobile = window.MinimogTheme && window.MinimogTheme.config && window.MinimogTheme.config.mqlMobile;
                effective = isMobile ? (vp.mediaGalleryMobile || vp.mediaGallery) : (vp.mediaGallery || vp.mediaGalleryMobile);
              }
              if (!effective) effective = el;
              var wasStale = vp.media !== effective;
              vp.media = effective;
              // Refresh cached slide refs so updateMedia() mutates the new slider, not the stale one
              if (effective) {
                if (effective.slider && effective.slider.slides) vp.slides = effective.slider.slides;
                if (effective.navSlider && effective.navSlider.slides) vp.slidesNav = effective.navSlider.slides;
                vp.mediaItems = effective.querySelectorAll(".m-product-media--item");
              }
              // Refresh variantGroupImages from the newly swapped wrapper.
              // NOTE: vp.getVariantGroupImageData() caches via early return when this.variantGroupImages exists.
              // We must clear it first OR parse #variantGroup directly to get fresh data.
              try {
                var freshVGEl = vp.querySelector('#variantGroup[type="application/json"]') ||
                                document.querySelector('#variantGroup[type="application/json"]');
                if (freshVGEl) {
                  vp.variantGroupImages = JSON.parse(freshVGEl.textContent);
                }
              } catch (e) {
                DEBUG && console.warn("[LinkedSwap:updateMedia] variantGroup re-parse failed:", e);
              }
              if (typeof vp.getProductJson === "function") {
                try {
                  var pd = vp.getProductJson();
                  if (pd) vp.productData = pd;
                } catch (e) {}
              }
              // Set currentVariant + currentVariantMedia from target, then trigger filter
              if (targetVariant) {
                vp.currentVariant = targetVariant;
                if (typeof vp.getDataImageVariant === "function") {
                  vp.getDataImageVariant(targetVariant.id);
                }
                // Determine readiness based on gallery mode:
                // - slider mode (mobile or desktop slider layout): slider.slides must be populated
                // - non-slider mode (grid/list layout): mediaItems must be populated
                var isSliderMode = effective && effective.mediaMode === "slider";
                var ready = false;
                if (isSliderMode) {
                  ready = !!(effective.slider && effective.slider.slides && effective.slider.slides.length > 0);
                } else {
                  ready = !!(vp.mediaItems && vp.mediaItems.length > 0);
                }
                if (ready && typeof vp.updateMedia === "function") {
                  var beforeSlides = effective.slider && effective.slider.slides ? effective.slider.slides.length : "n/a";
                  var beforeMediaItems = vp.mediaItems && vp.mediaItems.length;
                  // Diagnostic: dump first 5 data-media-id from slider slides + mediaItems for compare with currentVariantMedia
                  var sampleSliderIds = [], sampleItemIds = [];
                  if (effective.slider && effective.slider.slides) {
                    for (var si = 0; si < Math.min(5, effective.slider.slides.length); si++) {
                      var s = effective.slider.slides[si];
                      var inner = s.querySelector("[data-media-id]");
                      sampleSliderIds.push((inner && inner.dataset.mediaId) || "(no inner data-media-id)");
                    }
                  }
                  if (vp.mediaItems) {
                    for (var mi = 0; mi < Math.min(5, vp.mediaItems.length); mi++) {
                      var m = vp.mediaItems[mi];
                      var minner = m.querySelector("[data-media-id]");
                      sampleItemIds.push((minner && minner.dataset.mediaId) || "(no inner data-media-id)");
                    }
                  }
                  DEBUG && console.log("[LinkedSwap:diag] currentVariantMedia:", vp.currentVariantMedia,
                    "\n  sample slider slide IDs:", sampleSliderIds,
                    "\n  sample mediaItem IDs:", sampleItemIds);
                  try { vp.updateMedia(); } catch (e) {
                    DEBUG && console.warn("[LinkedSwap:updateMedia] vp.updateMedia threw:", e);
                  }
                  var afterSlides = effective.slider && effective.slider.slides ? effective.slider.slides.length : "n/a";
                  DEBUG && console.log("[LinkedSwap:updateMedia] vp.updateMedia ran. mode:", isSliderMode ? "slider" : "non-slider",
                    "| slider slides:", beforeSlides, "→", afterSlides,
                    "| mediaItems before:", beforeMediaItems);
                } else {
                  DEBUG && console.log("[LinkedSwap:updateMedia] SKIP vp.updateMedia — not ready. mode:",
                    isSliderMode ? "slider" : "non-slider",
                    "slides:", effective && effective.slider && effective.slider.slides && effective.slider.slides.length,
                    "mediaItems:", vp.mediaItems && vp.mediaItems.length);
                }

                // 5.8 fallback: variant-picker is thin (no updateMedia). Media filter
                // logic moved to <product-info>. Trigger it directly so non-slider
                // (grid) and slider modes both filter media to the target variant.
                // NOTE: productMedia is a getter-only prop on <product-info> — never assign.
                var pi = document.querySelector("product-info");
                if (pi) {
                  try {
                    try {
                      var freshVG = document.querySelector('#variantGroup[type="application/json"]');
                      if (freshVG) {
                        pi.variantGroupImagesData = JSON.parse(freshVG.textContent);
                        pi.enableVariantGroupImages = !!(pi.variantGroupImagesData && pi.variantGroupImagesData.enable);
                      }
                    } catch (e) {
                      DEBUG && console.warn("[LinkedSwap:updateMedia] product-info variantGroup re-parse failed:", e);
                    }
                    // Refresh initialMedias/initialThumbs from fresh DOM. These were
                    // snapshotted in constructor pointing to master's items; without
                    // refresh, handleVariantGroupImage filters stale master nodes
                    // against linked variant's media IDs → 0 matches → fallback path
                    // re-injects all master items into linked gallery.
                    var freshMedia = pi.productMedia;
                    if (freshMedia) {
                      pi.initialMedias = freshMedia.querySelectorAll(".m-product-media--item");
                      pi.initialThumbs = freshMedia.querySelectorAll(".m-product-media--slider__thumbnails [data-media-type]");
                      DEBUG && console.log("[LinkedSwap:updateMedia] refreshed pi.initialMedias:", pi.initialMedias.length, "initialThumbs:", pi.initialThumbs.length);
                    }
                    pi.currentVariant = targetVariant;
                    if (typeof pi.updateMedia === "function") {
                      try {
                        pi.updateMedia(targetVariant);
                        DEBUG && console.log("[LinkedSwap:updateMedia] product-info.updateMedia called for variant", targetVariant.id);
                      } catch (e) {
                        DEBUG && console.warn("[LinkedSwap:updateMedia] product-info.updateMedia threw:", e);
                      }
                    } else {
                      DEBUG && console.warn("[LinkedSwap:updateMedia] product-info has no updateMedia method");
                    }
                  } catch (eOuter) {
                    DEBUG && console.warn("[LinkedSwap:updateMedia] product-info sync threw (likely getter-only assign):", eOuter);
                  }
                } else {
                  DEBUG && console.warn("[LinkedSwap:updateMedia] <product-info> element not found");
                }
              }
              DEBUG && console.log("[LinkedSwap:updateMedia] variant-picker synced. wasStale:", wasStale,
                "| media:", vp.media && vp.media.tagName,
                "| slides:", vp.slides && vp.slides.length,
                "| currentVariantMedia:", vp.currentVariantMedia && vp.currentVariantMedia.length,
                "| variantGroupImages.enable:", vp.variantGroupImages && vp.variantGroupImages.enable);

              // Filter complete — reveal gallery. Wait one RAF so the swiper's
              // first layout pass on the now-filtered slide set is committed
              // before we drop visibility, otherwise the unfiltered strip can
              // still flash on slow phones.
              requestAnimationFrame(function () {
                currentMedia.style.visibility = "";
              });
            };

            // Collect promises, run single sync after ALL galleries settled (avoid race)
            var galleryPromises = [];
            galleries.forEach(function (el) {
              // Restore refs that constructor couldn't set (element wasn't in DOM during outerHTML parse)
              if (!el.container) {
                el.container = el.closest(".m-main-product--wrapper");
              }
              if (el.container && !el.view) {
                el.view = el.container.dataset.view || "product-template";
              }
              if (el.sectionId && !el.section) {
                el.section = el.closest('[data-section-id="' + el.sectionId + '"]');
              }
              // Re-query domNodes now that element is in DOM and children are parsed
              if (!el.domNodes || !el.domNodes.slider) {
                el.domNodes = queryDomNodes(el.selectors, el);
              }
              DEBUG && console.log("[LinkedSwap:updateMedia] Pre-fetch state for", el.tagName,
                "| container:", !!el.container,
                "| view:", el.view,
                "| domNodes.slider:", el.domNodes && !!el.domNodes.slider
              );
              // Skip duplicate product JSON network fetch by overriding getProductJson with cached data
              if (cachedProduct && typeof el.getProductJson === "function") {
                el.getProductJson = function () { return Promise.resolve(cachedProduct); };
              }
              var donePromise;
              if (typeof el.fetchProductData === "function") {
                DEBUG && console.log("[LinkedSwap:updateMedia] Calling fetchProductData() on", el.tagName, "data-product-handle:", el.dataset.productHandle);
                donePromise = el.fetchProductData().then(function () {
                  el.removeAttribute("data-media-loading");
                  if (el.firstElementChild) el.firstElementChild.style.opacity = "1";
                }).catch(function (err) {
                  DEBUG && console.warn("[LinkedSwap:updateMedia] fetchProductData FAILED for", el.tagName, err);
                  el.removeAttribute("data-media-loading");
                  if (el.firstElementChild) el.firstElementChild.style.opacity = "1";
                });
              } else if (typeof el.setupData === "function") {
                DEBUG && console.log("[LinkedSwap:updateMedia] Calling setupData() on", el.tagName);
                var setupResult = el.setupData();
                var postSetup = function () {
                  el.removeAttribute("data-media-loading");
                  if (el.firstElementChild) el.firstElementChild.style.opacity = "1";
                };
                if (setupResult && typeof setupResult.then === "function") {
                  donePromise = setupResult.then(postSetup).catch(postSetup);
                } else {
                  // setupData was sync
                  postSetup();
                  donePromise = Promise.resolve();
                }
              } else {
                DEBUG && console.warn("[LinkedSwap:updateMedia] No fetchProductData or setupData on", el.tagName);
                donePromise = Promise.resolve();
              }
              if (donePromise) galleryPromises.push(donePromise);
            });

            // After ALL galleries init, wait extra tick for swiper internals to settle, then sync ONCE.
            Promise.all(galleryPromises).then(function () {
              setTimeout(function () {
                // syncVariantPicker now picks its own effective gallery (visibility-based).
                // Pass first gallery as placeholder; it's only used as last-resort fallback.
                var freshGalleries = currentMedia.querySelectorAll("media-gallery, media-gallery-mobile");
                if (freshGalleries.length === 0) {
                  // No galleries to sync → restore visibility here so the hide
                  // applied before innerHTML replace doesn't leave media hidden.
                  currentMedia.style.visibility = "";
                }
                if (freshGalleries.length > 0) {
                  DEBUG && console.log("[LinkedSwap:updateMedia] Settled. Galleries available:",
                    Array.from(freshGalleries).map(function (g) {
                      return g.tagName + "(visible=" + (g.offsetParent !== null) +
                        ",slider=" + !!g.slider +
                        ",slides=" + (g.slider && g.slider.slides && g.slider.slides.length) + ")";
                    }).join(", "));
                  syncVariantPicker(freshGalleries[0]);
                }
              }, 50);
            });
          });
        });

        // Also update mobile title
        var mobileInfoCurrent = wrapper.querySelector(".m-main-product--info.md\\:m\\:hidden");
        var mobileInfoFetched = fetchedWrapper.querySelector(".m-main-product--info.md\\:m\\:hidden");
        if (mobileInfoCurrent && mobileInfoFetched) {
          var mobileTitle = mobileInfoCurrent.querySelector(".m-product-title");
          var fetchedMobileTitle = mobileInfoFetched.querySelector(".m-product-title");
          if (mobileTitle && fetchedMobileTitle) {
            mobileTitle.innerHTML = fetchedMobileTitle.innerHTML;
          }
        }
      });
  }

  // ---- Variant change interceptor ----

  function setupVariantInterceptor() {
    document.addEventListener("variant:changed", function (e) {
      DEBUG && console.log("[LinkedSwap:variant:changed] fired. isSwapped:", swapState.isSwapped, "isSyncing:", window.SellyColorSync && window.SellyColorSync.isSyncing());
      if (isSwapping) return; // swap mid-flight — avoid racing updateForm
      if (window.SellyColorSync && window.SellyColorSync.isSyncing()) return;
      if (!swapState.isSwapped || !swapState.linkedProduct) return;

      // Swatch King fired with original product's variant
      // Map to linked product's variant with same options
      var originalVariant = e.detail && e.detail.variant;
      DEBUG && console.log("[LinkedSwap:variant:changed] original variant:", originalVariant && originalVariant.id, originalVariant && originalVariant.title);
      if (!originalVariant) return;

      var currentOptions = getCurrentSelectedOptions();
      DEBUG && console.log("[LinkedSwap:variant:changed] currentOptions:", JSON.stringify(currentOptions));
      var linkedVariant = findMatchingVariant(
        swapState.linkedProduct,
        swapState.selectedColor,
        currentOptions
      );
      DEBUG && console.log("[LinkedSwap:variant:changed] linkedVariant:", linkedVariant && linkedVariant.id, linkedVariant && linkedVariant.title);

      if (linkedVariant) {
        // Override the form with linked product's variant
        updatePrice(linkedVariant);
        updateForm(swapState.linkedProduct, linkedVariant);
        // Update URL
        history.replaceState(
          { linkedProductSwap: true },
          "",
          "/products/" + swapState.linkedProduct.handle + "?variant=" + linkedVariant.id
        );

        // Re-filter media via product-info (see swatchClick block below for full rationale).
        var pi = document.querySelector("product-info");
        if (pi) {
          try { pi.abortController && pi.abortController.abort(); } catch (e) {}
          try {
            pi.currentVariant = linkedVariant;
            if (typeof pi.updateMedia === "function") {
              pi.updateMedia(linkedVariant);
              DEBUG && console.log("[LinkedSwap:variant:changed] pi.updateMedia called for linked variant", linkedVariant.id);
            }
          } catch (e) {
            DEBUG && console.warn("[LinkedSwap:variant:changed] pi.updateMedia threw:", e);
          }
        }
        emitVariantChangePubsub(linkedVariant);
      } else {
        DEBUG && console.warn("[LinkedSwap:variant:changed] NO matching linked variant found! Form NOT updated.");
      }
      if (window.SellyColorSync) window.SellyColorSync.sync();
    });

    // Fallback: intercept Swatch King option clicks directly
    // variant:changed may NOT fire if variant-picker can't match options to original product
    document.addEventListener("click", function (e) {
      if (isSwapping) return; // swap mid-flight — pointer-events lock should block, this is defense-in-depth
      if (!swapState.isSwapped || !swapState.linkedProduct) return;
      var swatchItem = e.target.closest(".swatch-view-item");
      if (!swatchItem) return;
      // Only intercept non-color swatches (size/print) inside main product picker
      var optionDiv = swatchItem.closest("[id^='swatch-option']");
      if (!optionDiv) return;
      var optName = (optionDiv.getAttribute("option-name") || "").toLowerCase();
      if (optName === "color") return; // color handled by linked-swap click handler

      // Wait for Swatch King to update aria-checked, then re-read options
      setTimeout(function () {
        var currentOptions = getCurrentSelectedOptions();
        DEBUG && console.log("[LinkedSwap:swatchClick] option:", optName, "currentOptions:", JSON.stringify(currentOptions));
        var linkedVariant = findMatchingVariant(
          swapState.linkedProduct,
          swapState.selectedColor,
          currentOptions
        );
        DEBUG && console.log("[LinkedSwap:swatchClick] linkedVariant:", linkedVariant && linkedVariant.id, linkedVariant && linkedVariant.title);
        if (linkedVariant) {
          updatePrice(linkedVariant);
          updateForm(swapState.linkedProduct, linkedVariant);
          history.replaceState(
            { linkedProductSwap: true },
            "",
            "/products/" + swapState.linkedProduct.handle + "?variant=" + linkedVariant.id
          );

          // Re-filter media via product-info. variant-picker emits
          // optionValueSelectionChange synchronously on input change → product-info
          // fetches MASTER section + master option_values → gets master variant →
          // calls handleVariantGroupImage(masterVariant) → mapping.find() returns
          // undefined (pi.variantGroupImagesData is linked's mapping) → throws
          // AFTER mediaWrapper.innerHTML="" → gallery goes empty.
          // Fix: abort that in-flight master fetch, then manually trigger
          // handleVariantGroupImage with the linked variant.
          var pi = document.querySelector("product-info");
          if (pi) {
            try { pi.abortController && pi.abortController.abort(); } catch (e) {}
            try {
              pi.currentVariant = linkedVariant;
              if (typeof pi.updateMedia === "function") {
                pi.updateMedia(linkedVariant);
                DEBUG && console.log("[LinkedSwap:swatchClick] pi.updateMedia called for linked variant", linkedVariant.id);
              }
            } catch (e) {
              DEBUG && console.warn("[LinkedSwap:swatchClick] pi.updateMedia threw:", e);
            }
          }
          // Notify sticky-atc + other variantChange subscribers about the new
          // linked variant. Otherwise sticky-atc button state stays on the
          // previously emitted variant (button text, sold-out state, etc.).
          emitVariantChangePubsub(linkedVariant);
        }
        // Re-assert after variant-picker may have overwritten (race condition)
        // variant-picker.onVariantChange fires async via Swatch King — may disable
        // button + overwrite input AFTER our 50ms handler
        setTimeout(function () {
          if (!linkedVariant) return;
          // Re-verify input value
          var inputVal = document.querySelector("input[name='id']");
          DEBUG && console.log("[LinkedSwap:swatchClick:verify] input[name=id] =", inputVal && inputVal.value, "expected:", linkedVariant.id);
          if (inputVal && String(inputVal.value) !== String(linkedVariant.id)) {
            DEBUG && console.warn("[LinkedSwap:swatchClick:verify] MISMATCH! Correcting...");
            inputVal.value = linkedVariant.id;
            inputVal.setAttribute("value", linkedVariant.id);
          }
          // Re-enable ATC buttons (variant-picker disables them when it can't match)
          if (linkedVariant.available) {
            document.querySelectorAll(".m-add-to-cart").forEach(function (btn) {
              btn.disabled = false;
              btn.classList.remove("disabled");
              var textEl = btn.querySelector(".m-add-to-cart--text");
              if (textEl && textEl.textContent !== (btn.getAttribute("data-atc-text") || "Add to cart")) {
                textEl.textContent = btn.getAttribute("data-atc-text") || "Add to cart";
              }
            });
            // Fix price visibility
            var pw = document.querySelector(".product-block-group--price .m-price");
            if (pw) pw.classList.remove("m:visibility-hidden");
            DEBUG && console.log("[LinkedSwap:swatchClick:verify] re-enabled ATC buttons");
          }
          refreshSwatchOOSState();
        }, 300);
      }, 50);
    });
  }

  // ---- Static Block Swap ----

  function saveOriginalBlocks() {
    if (swapState.originalBlocksHtml) return;
    swapState.originalBlocksHtml = {};
    ["description", "short_description", "meta"].forEach(function (type) {
      var el = document.querySelector(".main-product__block-" + type);
      if (el) {
        swapState.originalBlocksHtml[type] = el.innerHTML;
        DEBUG && console.log("[LinkedSwap:saveOriginalBlocks] saved block:", type, "length:", el.innerHTML.length);
      }
    });
    // Save all custom_liquid blocks (tagline, style number, tabs, etc.)
    swapState.originalBlocksHtml.custom_liquids = [];
    document.querySelectorAll(".main-product__block-custom_liquid").forEach(function (block) {
      swapState.originalBlocksHtml.custom_liquids.push({
        html: block.innerHTML,
        display: block.style.display || ""
      });
    });
    DEBUG && console.log("[LinkedSwap:saveOriginalBlocks] saved", swapState.originalBlocksHtml.custom_liquids.length, "custom_liquid blocks");
  }

  function updateStaticBlocks(handle) {
    var sectionEl = document.querySelector("[data-section-type='product-page']");
    if (!sectionEl) return Promise.resolve();
    var sectionId = sectionEl.dataset.sectionId;
    if (!sectionId) return Promise.resolve();

    DEBUG && console.log("[LinkedSwap:updateStaticBlocks] fetching section:", sectionId, "for handle:", handle);
    var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    return fetch(rootUrl + "products/" + handle + "?sections=" + encodeURIComponent(sectionId))
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data[sectionId];
        DEBUG && console.log("[LinkedSwap:updateStaticBlocks] section HTML received:", !!html, html ? html.length + " chars" : "null");
        if (!html) return;
        var parser = new DOMParser();
        var fetchedDoc = parser.parseFromString(html, "text/html");

        // Single-instance static blocks
        ["description", "short_description", "meta"].forEach(function (type) {
          var live = document.querySelector(".main-product__block-" + type);
          var fetched = fetchedDoc.querySelector(".main-product__block-" + type);
          DEBUG && console.log("[LinkedSwap:updateStaticBlocks] block:", type, "live:", !!live, "fetched:", !!fetched);
          if (live && fetched) live.innerHTML = fetched.innerHTML;
        });

        // Multi-instance: custom_liquid blocks (tagline, style#, tabs)
        var liveBlocks = document.querySelectorAll(".main-product__block-custom_liquid");
        var fetchedBlocks = fetchedDoc.querySelectorAll(".main-product__block-custom_liquid");
        DEBUG && console.log("[LinkedSwap:updateStaticBlocks] custom_liquid blocks — live:", liveBlocks.length, "fetched:", fetchedBlocks.length);
        liveBlocks.forEach(function (block, i) {
          if (fetchedBlocks[i]) {
            block.innerHTML = fetchedBlocks[i].innerHTML;
            block.style.display = "";
          } else {
            DEBUG && console.log("[LinkedSwap:updateStaticBlocks] hiding extra custom_liquid index:", i);
            block.style.display = "none";
          }
        });

        // Re-init collapsible tabs (innerHTML replacement kills click handlers)
        reinitCustomTabs();
        DEBUG && console.log("[LinkedSwap:updateStaticBlocks] DONE");
      })
      .catch(function (err) {
        DEBUG && console.warn("[LinkedSwap] updateStaticBlocks failed:", err);
      });
  }

  function restoreOriginalBlocks() {
    if (!swapState.originalBlocksHtml) return;
    DEBUG && console.log("[LinkedSwap:restoreOriginalBlocks] restoring saved blocks");
    ["description", "short_description", "meta"].forEach(function (type) {
      var el = document.querySelector(".main-product__block-" + type);
      if (el && swapState.originalBlocksHtml[type] !== undefined) {
        el.innerHTML = swapState.originalBlocksHtml[type];
        DEBUG && console.log("[LinkedSwap:restoreOriginalBlocks] restored block:", type);
      }
    });
    var liveBlocks = document.querySelectorAll(".main-product__block-custom_liquid");
    (swapState.originalBlocksHtml.custom_liquids || []).forEach(function (saved, i) {
      if (liveBlocks[i]) {
        liveBlocks[i].innerHTML = saved.html;
        liveBlocks[i].style.display = saved.display;
      }
    });
    DEBUG && console.log("[LinkedSwap:restoreOriginalBlocks] restored", (swapState.originalBlocksHtml.custom_liquids || []).length, "custom_liquid blocks");
    // Re-init collapsible tabs (innerHTML replacement kills click handlers)
    reinitCustomTabs();
  }

  // Re-attach click handlers for custom collapsible tabs after innerHTML swap.
  // Original script runs on DOMContentLoaded — won't re-fire after DOM replacement.
  function reinitCustomTabs() {
    var buttons = document.querySelectorAll(".custom-collapsible-tabs-v2 .collapsible");
    DEBUG && console.log("[LinkedSwap:reinitCustomTabs] found", buttons.length, "collapsible buttons");
    buttons.forEach(function (btn) {
      var icon = btn.querySelector(".tab-icon");
      if (icon) icon.textContent = "+";
      btn.classList.remove("active");
      var content = btn.nextElementSibling;
      if (content) content.style.maxHeight = null;

      btn.addEventListener("click", function () {
        var ct = this.nextElementSibling;
        var ic = this.querySelector(".tab-icon");
        var isActive = this.classList.contains("active");
        if (isActive) {
          this.classList.remove("active");
          if (ct) ct.style.maxHeight = null;
          if (ic) ic.textContent = "+";
        } else {
          this.classList.add("active");
          if (ct) ct.style.maxHeight = ct.scrollHeight + "px";
          if (ic) ic.textContent = "\u2212";
        }
      });
    });

    // Re-run fabric filter: if no custom.fabric metafield, extract from TECHNOLOGY tab
    var fabricWrapper = document.querySelector(".fabric-tab-wrapper");
    if (!fabricWrapper || fabricWrapper.dataset.hasFabricGuide === "true") return;
    var techContainer = document.querySelector(".tech-filtered-content");
    var fabricContainer = document.querySelector(".fabric-filtered-content");
    if (!techContainer || !fabricContainer) return;

    var tempDiv = document.createElement("div");
    tempDiv.innerHTML = techContainer.innerHTML;
    var allLis = tempDiv.querySelectorAll("li");
    var fabricLis = [];
    allLis.forEach(function (li) {
      var text = li.textContent.toLowerCase();
      if (text.includes("nylon") || text.includes("polyester")) {
        fabricLis.push(li.cloneNode(true));
        li.remove();
      }
    });
    tempDiv.querySelectorAll("ul").forEach(function (ul) {
      if (!ul.textContent.trim()) ul.remove();
    });
    techContainer.innerHTML = tempDiv.innerHTML;

    if (fabricLis.length > 0) {
      var fabricUl = document.createElement("ul");
      fabricLis.forEach(function (li) { fabricUl.appendChild(li); });
      fabricContainer.innerHTML = "";
      fabricContainer.appendChild(fabricUl);
      fabricWrapper.style.display = "block";
    }
    DEBUG && console.log("[LinkedSwap:reinitCustomTabs] fabric filter ran, fabricLis:", fabricLis.length);
  }

  // ---- Apps section (Judge.me reviews) swap ----
  //
  // Implementation moved to `assets/judgeme-swap.js`. Keep a thin delegate so
  // the swap-in / swap-back paths can stay agnostic of whether Judge.me lives
  // in the project (no-op if `judgeme-swap.js` isn't loaded).
  function updateAppsSection(handle) {
    if (window.JudgeMeSwap && typeof window.JudgeMeSwap.update === "function") {
      return window.JudgeMeSwap.update(handle);
    }
    DEBUG && console.warn("[LinkedSwap:updateAppsSection] window.JudgeMeSwap not loaded — skipping apps section refresh");
    return Promise.resolve();
  }

  // ---- Main Swap ----

  // Emit MinimogTheme.pubSubEvents.variantChange so 5.8 subscribers
  // (sticky-atc, recipient-form, price-per-item, final-sale-check) sync
  // to the post-swap variant. Mirrors the payload product-info.js emits.
  function emitVariantChangePubsub(variant) {
    if (!variant) return;
    if (!window.MinimogEvents || !window.MinimogTheme || !window.MinimogTheme.pubSubEvents) return;

    var mp = document.querySelector(".m-main-product");
    var sectionId = mp && mp.dataset.sectionId;
    if (!sectionId) {
      DEBUG && console.warn("[LinkedSwap:emitVariantChange] no sectionId on .m-main-product, skipping emit");
      return;
    }

    DEBUG && console.log("[LinkedSwap:emitVariantChange] sectionId:", sectionId, "variantId:", variant.id);
    window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.variantChange, {
      data: { variant: variant, sectionId: sectionId, html: null }
    });
  }

  function swapToLinkedProduct(handle, variantUrl, colorValue) {
    if (isSwapping) return;
    isSwapping = true;

    showLoading();

    // Move the selected ring to the clicked color immediately — BEFORE the async
    // product.js fetch — so the previous ring clears at once. Shrinks the window
    // where a fast second click could leave two rings visible. Re-applied (with
    // the label) inside the .then once the fetch confirms the target variant.
    updateSwatchKingSelectedColor(colorValue);

    var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    var capturedTargetVariant = null;

    fetch(rootUrl + "products/" + handle + ".js")
      .then(function (r) { return r.json(); })
      .then(function (product) {
        DEBUG && console.log("[LinkedSwap] Product JSON fetched:", product.title);

        // Save original product data on first swap
        if (!swapState.originalProduct) {
          var pdEl = document.querySelector("#productData");
          if (pdEl) {
            try { swapState.originalProduct = JSON.parse(pdEl.textContent); } catch (e) {}
          }
        }

        swapState.linkedProduct = product;
        swapState.selectedColor = colorValue;
        swapState.isSwapped = true;

        // Get current Size/Print selections from Swatch King
        var currentOptions = getCurrentSelectedOptions();
        var targetVariant = findMatchingVariant(product, colorValue, currentOptions);
        capturedTargetVariant = targetVariant;

        DEBUG && console.log("[LinkedSwap] Target variant:", targetVariant && targetVariant.id, targetVariant && targetVariant.title);

        // Update DOM
        updateTitle(product);
        updatePrice(targetVariant);
        updateForm(product, targetVariant);
        updateProductData(product);
        updateSwatchKingSelectedColor(colorValue);

        // Update URL
        var newUrl = "/products/" + handle;
        if (targetVariant) newUrl += "?variant=" + targetVariant.id;
        history.pushState({ linkedProductSwap: true }, "", newUrl);

        // Save original static blocks before first swap
        saveOriginalBlocks();

        // Update images + static content blocks + apps section in parallel.
        // Apps section refresh ensures Judge.me widget reflects the new
        // product's review state (empty → CSS :has() hide rule in
        // snippets/functional-fixes.liquid collapses the wrapper).
        return Promise.all([
          updateMedia(handle, targetVariant, product),
          updateStaticBlocks(handle),
          updateAppsSection(handle)
        ]);
      })
      .then(function () {
        var p = swapState.linkedProduct;
        if (p) {
          DEBUG && console.log("[LinkedSwap] Dispatching refresh_product pid:", p.id, typeof p.id);
          window.dispatchEvent(new CustomEvent("refresh_product", { detail: { pid: p.id } }));
          if (window.SellyColorSync) window.SellyColorSync.sync();
        }
        emitVariantChangePubsub(capturedTargetVariant);
        scheduleSwatchOOSRefresh();
        // Single rAF: SK consumes refresh_product synchronously inside
        // dispatchEvent above; one frame is enough for paint + variant-picker
        // re-wire before releasing the pointer-events lock. isSwapping guards
        // on variant:changed + click handlers cover any straggler events.
        requestAnimationFrame(function () {
          hideLoading();
          isSwapping = false;
          DEBUG && console.log("[LinkedSwap] DONE — swap complete!");
        });
      })
      .catch(function (err) {
        console.error("[LinkedSwap] Swap failed:", err);
        isSwapping = false;
        // Fallback to navigation
        if (variantUrl) {
          window.location.href = variantUrl;
        } else {
          hideLoading();
        }
      });
  }

  // ---- Swap Back to Master ----

  function swapBackToMaster(colorValue) {
    if (isSwapping || !swapState.isSwapped || !swapState.originalProduct) return;
    isSwapping = true;
    showLoading();

    var product = swapState.originalProduct;
    DEBUG && console.log("[LinkedSwap] Swapping back to master:", product.title, "color:", colorValue);

    var currentOptions = getCurrentSelectedOptions();
    var targetVariant = findMatchingVariant(product, colorValue, currentOptions);

    DEBUG && console.log("[LinkedSwap] Master variant:", targetVariant && targetVariant.id, targetVariant && targetVariant.title);

    // Update DOM back to master product
    updateTitle(product);
    updatePrice(targetVariant);
    updateForm(product, targetVariant);
    updateProductData(product);
    updateSwatchKingSelectedColor(colorValue);

    // Reset swap state
    swapState.isSwapped = false;
    swapState.linkedProduct = null;
    swapState.selectedColor = colorValue;

    // Update URL back to master
    var newUrl = "/products/" + product.handle;
    if (targetVariant) newUrl += "?variant=" + targetVariant.id;
    history.pushState({}, "", newUrl);

    // Restore static content blocks immediately (synchronous, no fetch needed)
    restoreOriginalBlocks();

    // Update images + apps section (Judge.me) in parallel
    Promise.all([
      updateMedia(product.handle, targetVariant, product),
      updateAppsSection(product.handle)
    ])
      .then(function () {
        window.dispatchEvent(new CustomEvent("refresh_product", { detail: { pid: product.id } }));
        if (window.SellyColorSync) window.SellyColorSync.sync();
        emitVariantChangePubsub(targetVariant);
        scheduleSwatchOOSRefresh();
        // isSwapped is now false, so the refresh's continuous self-heal is off.
        // SK may still re-assert a stale native ring after its refresh_product
        // re-render — re-clear to the master color across a couple of frames.
        requestAnimationFrame(function () { reassertSelectedColor(colorValue); });
        setTimeout(function () { reassertSelectedColor(colorValue); }, 150);
        requestAnimationFrame(function () {
          hideLoading();
          isSwapping = false;
          DEBUG && console.log("[LinkedSwap] Swap back complete!");
        });
      })
      .catch(function () {
        hideLoading();
        isSwapping = false;
      });
  }

  // ---- Native Swatch Click Interceptor ----
  // When swapped, intercept clicks on native (master product) color swatches
  // to swap back instead of letting Swatch King handle it

  document.addEventListener("click", function (e) {
    if (window.SellyColorSync && window.SellyColorSync.isSyncing()) return;
    if (!swapState.isSwapped) return; // only intercept when swapped

    // Find if click is on a non-linked swatch item
    var swatch = e.target.closest(".swatch-view-item:not(.swatch-view-item--linked)");
    if (!swatch) {
      DEBUG && console.log("[LinkedSwap:swapBackClick] click ignored — no .swatch-view-item:not(--linked) ancestor. target:", e.target && e.target.tagName, e.target && e.target.className);
      return;
    }

    // Must be inside the Color option of the main variant picker (not .linkedprod, not product cards)
    var colorOption = swatch.closest('[option-name="Color"], [option-name="color"]');
    DEBUG && console.log("[LinkedSwap:swapBackClick] swatch hit. orig-value:", swatch.getAttribute("orig-value"), "| colorOption:", !!colorOption, "| in .linkedprod:", colorOption ? !!colorOption.closest(".linkedprod") : "n/a", "| in .main-product__block-variant_picker:", colorOption ? !!colorOption.closest(".main-product__block-variant_picker") : "n/a");
    if (!colorOption) return;
    if (colorOption.closest(".linkedprod")) return;
    if (!colorOption.closest(".main-product__block-variant_picker")) return;

    // This is a native color swatch click while swapped — swap back to master
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    var color = swatch.getAttribute("orig-value");
    DEBUG && console.log("[LinkedSwap:swapBackClick] intercept fired → swapBackToMaster:", color);
    if (color) {
      swapBackToMaster(color);
    }
  }, true); // capture phase — runs before Swatch King's handler

  // Back button handler
  window.addEventListener("popstate", function (e) {
    if (e.state && e.state.linkedProductSwap) {
      window.location.reload();
    }
  });

  // Setup variant interceptor
  setupVariantInterceptor();

  // Initial OOS sweep + observer setup. Observer reacts to SK mutations in
  // ~1 rAF, replacing the previous multi-second polling schedule.
  if (swapState.originalProduct) {
    scheduleSwatchOOSRefresh();
    setupSwatchOOSObserver();
    // Re-bind observer after first swap completes — SK may have replaced its
    // internal subtree during refresh_product, detaching prior observers.
    window.addEventListener("refresh_product", function () {
      setTimeout(setupSwatchOOSObserver, 50);
    });
  }

  // Debug: intercept ATC form submit to log what variant ID is sent
  document.addEventListener("submit", function (e) {
    var form = e.target;
    if (!form || !form.querySelector("input[name='id']")) return;
    var idInput = form.querySelector("input[name='id']");
    DEBUG && console.log("[LinkedSwap:ATC] form submit — variant ID:", idInput.value,
      "isSwapped:", swapState.isSwapped,
      "linkedProduct:", swapState.linkedProduct && swapState.linkedProduct.handle);
  }, true); // capture phase — runs before product-form handler

  // Expose globally
  window.LinkedProductSwap = {
    swap: swapToLinkedProduct
  };
})();
